export { default } from './text-editor';
